import React from 'react';
import {connect} from "react-redux";

import PermissionProperties from '../../../../config/permission.js'
import FormHelper from '../../../../master/import/helper/form.js'
import UserHelper from '../../../../helper/user.js'
import PopoverHelper from '../../../../utils/PopoverHelper';
import Presenter from '../../../../master/import/presenter.js';
import RequestProperties from '../../../../master/import/helper/request.props.js';
import ModalAssetLocation from '../../../../master/import/helper/component/Modal/ModalAssetLocation.js';

// TOAST
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import windowStop from '../../../../utils/windowStop.js';

class ImportScreen extends React.Component {
  constructor() {
    super();

    this.initialState = {
    	asset 						: '',
    	asset_type 				: '',
    	asset_status 			: '',
    	contacts 					: '',
    	contractor 				: '',
    	departement 			: '',
    	maintenance_type 	: '',
    	site_status 			: '',
    	site_type 				: '',
    	coverage 					: '',
      site              : '',
      location          : '',
    	isLoading 				: {},
      modalAssetLocation: false,
    }

    this.state 					= this.initialState;
    this.fileTypeAccept = '.csv';
    this.importType 		= [];

    this.openModalAssetLocation = this.openModalAssetLocation.bind(this);
    this.closeModalAssetLocation = this.closeModalAssetLocation.bind(this);
    this.saveAssetLocation = this.saveAssetLocation.bind(this);
    this.cancelAssetLocation  = this.cancelAssetLocation.bind(this);
  }

  componentWillUnmount(){
    windowStop()
  }

  openModalAssetLocation(){
    this.setState({
      modalAssetLocation : true
    })
  }

  closeModalAssetLocation(){
    this.setState({
      modalAssetLocation : false
    })
  }

  saveAssetLocation(data){
    this.setState({
      site : data.site,
      location : data.location
    })
  }

  cancelAssetLocation(){
    this.refs.asset.value = ''
    this.importType.splice(
        this.importType.findIndex(i => i === 'asset'), 1
    );
    this.setState({ asset : '' })
  }

  onChangeFiles(e){
  	if(!FormHelper.validateForm(e.target.value)) {
  		e.target.value = '';
  		return
  	}
  	const file = e.target.files[0];
  	if(file){
      if (e.target.name === 'asset'){
        this.openModalAssetLocation();
      }
  		this.setState({ [e.target.name] : file })
  		this.importType.push(e.target.name)
  	}else{
  		this.setState({ [e.target.name] : '' })
  	}
  }

  onFinishImporting(thisState){
  	this.importCount -= 1

  	this.newState = {
  		isLoading : {
  			...this.newState.isLoading,
  			[thisState] : false	
  		},
  		[thisState] 	: ''
  	}

  	if(this.importCount <= 0){
  		window.alert(this.importSummary)
  		this.newState.isLoading.button = false
  		this.setState(this.newState)
  	}
  }

  import(){

  	if(this.importType.length < 1){
  		toast.error('Nothing to Import!')
  		return
  	}

  	this.newState 			= {};
  	this.importSummary 	= 'IMPORT RESULT : \n';
  	this.importCount 		= this.importType.length;

  	for (let i = 0; i < this.importType.length; i++) {
  		this.newState = {
  			isLoading : {
  				...this.newState.isLoading,
  				[this.importType[i]] : true,
  			}
  		}
  	}
  	this.newState.isLoading.button = true
  	this.setState(this.newState)

  	for (let i = 0; i < this.importType.length; i++) {
	  	Presenter.Register(
	  		RequestProperties.Register(
	  			{
	  				importType 	: this.importType[i],
	  				file 				: this.state[this.importType[i]],
            site        : this.state.site,
            location    : this.state.location
	  			},
	  			this.onImportSuccess.bind(this), 
	  			this.onImportFailed.bind(this), 
	  			this
	  		)
	  	)
  	}

  	this.importType = []
  }

  onImportSuccess(params, response){
  	let errorLine = []
  	if (response.data.errors > 0){
  		for (var i = 0; i < response.data.detail.length; i++) {
  			if (i > 4){
  				errorLine.push('...')
  				break
  			}else{
  				errorLine.push(response.data.detail[i].line)
  			}
  		}
  	}
  	this.importSummary += params.data.ImportType 
  											+ ' importing result : ' 
  											+ response.data.success + ' success, '
  											+ response.data.errors + ' errors' 
  											+ (response.data.errors > 0 ? '( line : ' + errorLine.toString() + ' )' : '')
  											+ '\n'

  	this.onFinishImporting(params.data.ImportType)
  }

  onImportFailed(params, response){
  	this.importSummary += params.data.ImportType + ' upload failed!'
  	this.onFinishImporting(params.data.ImportType)
  }

  renderInputField(label, name, downloadTemplate){
  	if(this.state.isLoading[name] === false || this.state.isLoading[name] === undefined){
	  	return(
	  		<div className="form-group">
	  			<label>{label}</label>
	        <div className="input-group suffix">
	        	<input 
	        		type="file" 
	        		className="form-control"
	        		name={name} 
	        		id={name}
	        		ref={name}
	        		accept={this.fileTypeAccept}
	        		onChange={event => this.onChangeFiles(event)}
	        	/>
	          <span className="input-group-addon white-background" style={{ padding : 0}}>
	            <button className="btn btn-link">Template (.csv)</button>
	          </span>
	        </div>
	      </div>
	  	)
  	}else{
	  	return(
	  		<div className="form-group">
	  			<label>{label}</label>
	  			<div style={{ fontSize : '1.5em'}}>
	  				<i className="fa fa-cog fa-spin fa-fw"></i>&nbsp;<i>Importing . . .</i>
	  			</div>
	  		</div>
	  	)
  	}
  }

  renderImportButton(){
  	if(this.state.isLoading.button === false || this.state.isLoading.button === undefined){
  		return(
  			<button type="button" className="btn btn-primary pull-right" onClick={() => this.import()}>Import</button>
  		)
  	}else{
  		return(
  			<button type="button" className="btn btn-default pull-right" disabled>
  				<i className="fa fa-cog fa-spin fa-fw"></i>&nbsp;Importing
  			</button>
  		)
  	}
  }

  renderImport() {
    if(UserHelper.HasPermission(PermissionProperties.MASTER.SITE_TYPE.REGISTER, this.props.UserReducer)) {
        return (
          <div className="card-block">
              <div className="row">
                <div className="col-md-12">
                  <div className="list-separator m-top-15" style={{ border : 'none'}}>
                    <div className="item-inner">
                      DATA MASTER
                      <PopoverHelper 
                        id="default_mapping" 
                        content="Import files (.csv) to Data Master."
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Asset Status','asset_status')}
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Asset Type','asset_type')}
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Contacts','contacts')}
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Contractor','contractor')}
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Departement','departement')}
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Maintenance Type','maintenance_type')}
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Site Status','site_status')}
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Site Type','site_type')}
                </div>
                {/*<div className="col-md-6">
                  {this.renderInputField('Coverage','coverage')}
                </div>*/}
              </div>
               <div className="row">
                <div className="col-md-12">
                  <div className="list-separator m-top-15" style={{ border : 'none'}}>
                    <div className="item-inner">
                      Asset Master
                     <PopoverHelper 
                        id="site_type_mapping" 
                        content="Import files (.csv) to Asset Master."
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  {this.renderInputField('Asset','asset')}
                </div>
              </div>
              <hr/>
              {this.renderImportButton()}
          </div>
        )
    } else {
        return(
            <div className="card-block">
                <div className="h-60vh-c flex-row align-items-center">
                    <h3 className="text-center color-visible">You dont have permision</h3>
                </div>
            </div>
        )
    }
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="animated fadeIn">
            <div className="card">
                <div className="card-header">
                    <i className="fa fa-align-justify"></i>Import 
                </div>
                {this.renderImport()}
            </div>
        </div>
        <ModalAssetLocation 
          isOpen = {this.state.modalAssetLocation}
          closeModal = {this.closeModalAssetLocation}
          onCancel = {this.cancelAssetLocation}
          onSave = {this.saveAssetLocation}
          UserReducer = {this.props.UserReducer}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    UserReducer: state.UserReducer,
  };
};
export default connect(mapStateToProps)(ImportScreen)


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/master/import.js